<div class="scroll-container" #scrollContainer>
  <button class="scroll-button scroll-up-button" (pointerdown)="upButtonDown($event)" (pointerup)="upButtonUp($event)" (pointerleave)="upButtonLeave($event)">
    <span class="scroll-up"></span>
  </button>

  <div class="scroll-content" (scroll)="onScroll($event)">
    <ng-content></ng-content>
  </div>

  <button class="scroll-button scroll-down-button"  (pointerdown)="downButtonDown($event)" (pointerup)="downButtonUp($event)" (pointerleave)="downButtonLeave($event)">
    <span class="scroll-down"></span>
  </button>

  <div class="scroll-fade-top"></div>
  <div class="scroll-fade-bottom"></div>
</div>
